/* eslint func-names: ["error", "never"] */
/* eslint no-console: ["error", { allow: ["log"] }] */
import { csvParse } from "d3-dsv";

import Legend from "./Legend";
import MapboxMap from "./MapboxMap";
import Sizes from "./Utils/Sizes";
import ColorScales from "./Utils/ColorScales";
import Settings from "./Settings";
import EventEmitter from "./Utils/EventEmitter";

export default class EPMapboxMap extends EventEmitter {
  constructor(opts) {
    super();
    this.settings = new Settings(opts);

    if (this.settings.get("debug") == true) {
      window.instance = this;
      console.log(this);
    }

    this.parseData = this.settings.get("parseData");
    // set an accesor to the main container
    this.el = document.getElementById(this.settings.get("container"));

    this.map = {};
    this.mapOps = opts;

    this.colorScales = new ColorScales({
      main: this,
      opts: { colorScales: this.settings.get("modules").colorScales },
    });

    if (this.settings.get("createLegend") === true) {
      this.legend = new Legend({ main: this });
    }
    this.loadData();
  }

  init() {
    this.sizes = new Sizes({ main: this });
    this.map = new MapboxMap({ opts: this.mapOps, main: this });
    this.bindMapEvents();

    return this;
  }

  bindMapEvents() {
    // accessor to map's event
    if (this.map && this.map.events) {
      this.map.events.bindMapEvents();
    }
    return this;
  }

  loadData() {
    if (!this._data && this.settings.get("dataFile") !== undefined) {
      return this.setupData();
    }

    // si los datos ya están cargados o no hay fuente emitimos 'ready' inmediatamente
    setTimeout(() => this.trigger("ready", [this]), 0);
    return Promise.resolve(this);
  }

  setupData() {
    const url = this.settings.get("dataFile");

    return this.makeRequest(url)
      .then(this.parseData.bind(this))
      .then(this.init.bind(this))
      .then(() => {
        this.trigger("ready", [this]);
        return this;
      });
  }

  makeRequest(url) {
    return new Promise(function (resolve, reject) {
      var xhr = new XMLHttpRequest();
      xhr.open("GET", url);
      xhr.onload = function () {
        if (xhr.status >= 200 && xhr.status < 300) {
          const fileExtension = url.split(/[#?]/)[0].split(".").pop().trim();
          if (fileExtension === "json") {
            resolve(JSON.parse(xhr.response));
          } else {
            resolve(csvParse(xhr.response));
          }
        } else {
          reject({
            status: xhr.status,
            statusText: xhr.statusText,
          });
        }
      };
      xhr.onerror = function () {
        reject({
          status: xhr.status,
          statusText: xhr.statusText,
        });
      };
      xhr.send();
    });
  }

  initEPIOScroller() {
    // TODO: La carga en el viewport no esta cargando correctamente
    if (this.settings.get("EPIOScroller")) {
      const {
        wrapper,
        background,
        foreground,
        observeOnce,
        debug,
        observerOpts,
      } = this.settings.get("EPIOScroller");
      const wrapperDiv = document.querySelector(wrapper);
      new EPIOScroller({
        background: document.querySelector(background),
        foreground: wrapperDiv.querySelectorAll(foreground),
        observeOnce: observeOnce || false,
        debug: debug || false,
        observerOpts: observerOpts || {
          rootMargin: "0px 0px -100px 0px",
        },
        onEnter: (el, index, data) => {
          this.loadData().bindMapEvents();
        },
      });
      return;
    }
    this.loadData().bindMapEvents();
  }
}
